/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import { ACTION_TYPES } from '../actions/ActionTypes';

export const initialState = {
  isDataLoaded: false,
  assessmentDetails: {},
  assessments: [],
  groupYearSelectedVal: null,
  BasicDetails:[]

}

const Assessment = (state = initialState, { type, payload }) => {
  switch(type){

    case ACTION_TYPES.FETCH_ASSESSMENTS:
      return {...state, assessments: payload, isDataLoaded: true } 

    case ACTION_TYPES.FETCH_ASSESSMENT_DETAILS:
      return {...state, assessmentDetails: payload } 

    case ACTION_TYPES.GROUP_YEAR_CHANGE:
      return {...state, groupYearSelectedVal: payload }
    case ACTION_TYPES.FETCH_BASICASSESSMENT_DETAILS:
      return { ...state, BasicDetails: payload }  



    default:
      return { ...state }
  }
}

export default Assessment;